import { makeStyles } from 'tss-react/mui';

const IMAGE_AREA_WIDTH = 123;
const GRADIENT_START = '58.17%';

export const useStyles = makeStyles()(({ tokens }) => ({
  root: {
    background: `linear-gradient(90deg, ${tokens.colors.bg.light.primary} ${GRADIENT_START}, ${tokens.colors.accent.bg.blue} 100%)`,
  },
  imageArea: {
    position: 'relative',
    flexShrink: 0,
    width: IMAGE_AREA_WIDTH,
    '& > svg': {
      position: 'absolute',
      top: 0,
      right: 0,
    },
  },
}));
